module.exports = __webpack_public_path__ + "static/media/no-knowledge-point.658c792c.png";